export const defaultsQuery = `
  Defaults {
    thumbnail {
      id
      sizes {
        thumbnail2x {
          url
        }
        thumbnail {
          url
        }
      }
    }
  }
`
